<template>
    <kgr-generic-select
        display="title"
        :loading="loading"
        :value="selection"
        :options="clubExamTypes"
        @post-input="updateClubExamType($event)"
    />
</template>

<script>
import ClubExamType from '../../../../js/dto/club/ClubExamType';
import ClubExamTypeRepository from '../../../../js/repository/club/ClubExamTypeRepository';
import GenericSelect from './GenericSelect.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubExamType,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            selection: null,
            clubExamTypes: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.exam.type');
        },
    },
    methods: {
        load() {
            ClubExamTypeRepository.findByClubId(this.clubId, false)
                .then(data => {
                    this.loading = false;
                    this.clubExamTypes = data;
                    if (this.value !== null) {
                        this.clubExamTypes.forEach(clubExamType => {
                            if (clubExamType.id === this.value.id) {
                                this.selection = clubExamType;
                            }
                        });
                    }
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        updateClubExamType(value) {
            this.selection = value;
            this.$emit('input', this.selection);
            this.$nextTick(() => {
                this.$emit('post-input', this.selection);
            });
        },
    },
    created() {
        this.load();
    },
}
</script>
